/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const AssignmentIcon = /*#__PURE__*/ createSvgIcon(
  'AssignmentIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M4.167 17.5c-.459 0-.851-.163-1.177-.49a1.605 1.605 0 01-.49-1.177V4.167c0-.459.163-.851.49-1.177.326-.327.718-.49 1.177-.49h3.5c.18-.5.482-.903.906-1.208A2.38 2.38 0 0110 .833a2.38 2.38 0 011.427.459c.424.305.726.708.906 1.208h3.5c.459 0 .851.163 1.177.49.327.326.49.718.49 1.177v11.666c0 .459-.163.851-.49 1.178-.326.326-.718.489-1.177.489H4.167zm0-1.667h11.666V4.167H4.167v11.666zm2.5-1.666h4.166c.236 0 .434-.08.594-.24.16-.16.24-.357.24-.594a.807.807 0 00-.24-.593.807.807 0 00-.594-.24H6.667a.806.806 0 00-.594.24.806.806 0 00-.24.593c0 .236.08.434.24.594.16.16.358.24.594.24zm0-3.334h6.666c.236 0 .434-.08.594-.24.16-.159.24-.357.24-.593a.806.806 0 00-.24-.594.806.806 0 00-.594-.24H6.667a.806.806 0 00-.594.24.806.806 0 00-.24.594c0 .236.08.434.24.594.16.16.358.24.594.24zm0-3.333h6.666c.236 0 .434-.08.594-.24.16-.16.24-.357.24-.593a.806.806 0 00-.24-.594.806.806 0 00-.594-.24H6.667a.806.806 0 00-.594.24.806.806 0 00-.24.594c0 .236.08.434.24.593.16.16.358.24.594.24zM10 3.542a.607.607 0 00.625-.625.607.607 0 00-.625-.625.607.607 0 00-.625.625.607.607 0 00.625.625z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default AssignmentIcon;
